function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.75 7.688c-2.134 0-4.121.617-5.812 1.668V6.562a6.337 6.337 0 00-1.867-4.508C9.866.851 8.265.188 6.562.188S3.259.851 2.055 2.055A6.333 6.333 0 00.188 6.562v5.625a.75.75 0 001.5 0V6.562c0-1.302.507-2.526 1.428-3.447.921-.92 2.146-1.428 3.447-1.428s2.526.507 3.447 1.428a4.848 4.848 0 011.428 3.447v3.908c-2.294 2.028-3.75 4.983-3.75 8.279 0 6.1 4.962 11.062 11.062 11.062s11.062-4.963 11.062-11.062c0-6.099-4.962-11.061-11.062-11.061zm0 20.624c-5.273 0-9.562-4.29-9.562-9.562 0-5.273 4.29-9.562 9.562-9.562 5.272 0 9.562 4.29 9.562 9.562 0 5.272-4.29 9.562-9.562 9.562zm.75-11.437v3.75a.75.75 0 01-1.5 0v-3.75a.75.75 0 011.5 0z"
})));